import UAParser from 'ua-parser-js';

export default class UserAgent {
  static parser = new UAParser();

  static isIpad() {
    // https://stackoverflow.com/a/58064481
    return (
      /iPad/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  static isIOS() {
    return this.parser.getOS().name === 'iOS';
  }

  static isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  static isAndroidWebView() {
    // https://developer.chrome.com/multidevice/user-agent#webview_user_agent
    return /wv/i.test(navigator.userAgent);
  }

  static isInNativeWebView() {
    return this.isAndroidWebView() || this.isIOSWebView();
  }

  static isIOSWebView() {
    // https://stackoverflow.com/a/10170885
    // https://stackoverflow.com/a/58064481
    return (
      /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
        navigator.userAgent,
      ) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  }

  static isTouchDevice() {
    // https://stackoverflow.com/a/45498023
    const hasTouchScreen =
      'ontouchstart' in window ||
      'ontouchstart' in document.documentElement ||
      navigator.maxTouchPoints > 2 ||
      navigator.msMaxTouchPoints > 2;

    return hasTouchScreen;
  }
}
